export default __webpack_public_path__ + "static/media/Explorastory_promo_video.3824889c.mp4";